/* Generated by scripts/sync-theme-boot.mjs — do not edit. */
export const COMMO_THEME_CONTRACT = {
  storageKey: 'commo_theme_preference',
  darkClass: 'ion-palette-dark',
  modeClass: 'md',
  defaultPreference: 'system',
  themeColorLight: '#456179',
  themeColorDark: '#000000',
  statusBarLight: 'default',
  statusBarDark: 'black-translucent',
} as const;

/** FOUC theme-boot.js と同じ判定。systemDark は prefers-color-scheme: dark。 */
export function resolveCommoThemeIsDark(
  pref: string,
  systemDark: boolean,
): boolean {
  return pref === 'dark' || (pref !== 'light' && systemDark);
}
